import React from 'react';
import Login from './pages/Login';
import Login_Anand from './pages/Login_Anand';
import Login1 from './pages/Login1';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LayoutWrapper from './layout/LayoutWrapper';
import Dashboard from './pages/Dashboard';
import Profile from './pages/ProfilePage';
import EmployeeMaster from './pages/EmployeeMaster';
import SbuModel from './pages/SbuModel';
import SbuEditModel from './pages/SbuEditModel';
import SBU from './pages/Sbu';
import USERS from './pages/Users';
import PaygroupModel from './pages/PaygroupModel';
import PaygroupEditModel from './pages/PaygroupEditModel';
import PAYGROUP from './pages/Paygroup';
import RegionModel from './pages/RegionModel';
import RegionEditModel from './pages/RegionEditModel';
import REGION from './pages/Region';
import CityModel from './pages/CityModel';
import CityEditModel from './pages/CityEditModel';
import CITY from './pages/City';
import ClusterModel from './pages/ClusterModel';
import ClusterEditModel from './pages/ClusterEditModel';
import CLUSTER from './pages/Cluster';
import LocationModel from './pages/LocationModel';
import LocationEditModel from './pages/LocationEditModel';
import LOCATION from './pages/Location';
import DeptCategoryModel from './pages/DeptCategoryModel';
import DeptCategoryEditModel from './pages/DeptCategoryEditModel';
import DEPTCATEGORY from './pages/DeptCategory';
import MainDeptModel from './pages/MainDeptModel';
import MainDeptEditModel from './pages/MainDeptEditModel';
import MAINDEPT from './pages/MainDept';
import Grade from './pages/Grade';
import GradeEditModel from './pages/GradeEditModel';
import GradeModel from './pages/GradeModel';
import BloodGroup from './pages/BloodGroup';
import BloodGroupEditModel from './pages/BloodGroupEditModel';
import BloodGroupModel from './pages/BloodGroupModel';
import Roster from './pages/Roster';
import RosterEditModel from './pages/RosterEditModel';
import RosterModel from './pages/RosterModel';
import Designation from './pages/Designation';
import DesignationEditModel from './pages/DesignationEditModel';
import DesignationModel from './pages/DesignationModel';
import Religion from './pages/Religion';
import ReligionEditModel from './pages/ReligionEditModel';
import ReligionModel from './pages/ReligionModel';
import Modality from './pages/Modality';
import ModalityEditModel from './pages/ModalityEditModel';
import ModalityModel from './pages/ModalityModel';
import Submodality from './pages/Submodality';
import SubmodalityEditModel from './pages/SubmodalityEditModel';
import SubmodalityModel from './pages/SubmodalityModel';
import SubmodClassEditModel from './pages/SubmodClassEditModel';
import SubmodClassModel from './pages/SubmodClassModel';
import SubmodClass from './pages/SubmodClass';
import AddHrAssessmentPage from "./components/AddHrAssessmentForm";
import ChangePassword from './pages/ChangePassword';
import ResetTravelPasswords from './pages/ResetTravelPasswords';
import AttendanceSummary from './pages/AttendanceSummary';
import AssessmentPage1 from './pages/AssesmentPage';
import ManagerAssessmentPage from './pages/ManagerAssessmentPage';
import HrAssessmentPage from './pages/HrAssessmentPage';
// import AssessmentPage from "./components/AssessmentPage";
import AssessmentDetail from "./components/AssessmentDetail";
import PositionModel from './pages/PositionModel';
import PositionEditModel from './pages/PositionEditModel';
import Position from './pages/Position';
import Degree from './pages/Degree';
import DegreeModel from './pages/DegreeModel';
import DegreeEditModel from './pages/DegreeEditModel';
import Caste from './pages/Caste';
import CasteModel from './pages/CasteModel';
import CasteEditModel from './pages/CasteEditModel';
import SubDept from './pages/SubDept';
import SubDeptModel from './pages/SubDeptModel';
import SubDeptEditModel from './pages/SubDeptEditModel';
import UserEditModel from './pages/UserEditModel';
import UserModel from './pages/UserModel';
import Attendance from './pages/Attendance';
import PAYROLL from './pages/Payroll';
import EditManagerRadiologistStatus from './pages/EditManagerRadiologistStatus';
import EditHrRadiologistStatus from './pages/EditHrRadiologistStatus';
import AddAssessmentPage from "./components/AddAssessmentForm";
import ViewRadiologistStatus from './pages/ViewRadiologistStatus';
import EditRadiologistStatus from './pages/EditRadiologistStatus';
import Holiday from './pages/Holiday';
import HolidayModel from './pages/HolidayModel';
import DutyRoster from './pages/DutyRoster';
import DutyRosterBulk from './pages/DutyRosterBulk';
import EmployeeAttendance from './pages/EmployeeAttendance';
import EmployeeAttendanceCalendar from './pages/EmployeeAttendanceCalender';
import ForgetPassword from './pages/Forget-password';
import DoctorsShiftMaster from './pages/masterPages/DoctorsShiftMaster';
import EmployeeShiftMaster from './pages/masterPages/EmployeeShiftMaster';
import MyLeaves from './pages/MyLeaves';
import LeaveRequestsAdmin from './pages/LeaveRequestsAdmin';
import LeaveCalendar from './pages/LeaveCalendar';
import LeaveManagement from './pages/LeaveManagement/LeaveManagement';
import DoctorAttendanceSummary from './pages/DoctorAttendanceSummery';
import EmployeeAttendanceSummar from './pages/EmployeeAttendanceSummary';
import PoojariAttendanceSummery from './pages/PoojariAttendanceSummery';
import EditHR1RadiologistStatus from './pages/EditHr1RadiologistStatus';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import EmployeeAttendanceDetails from './pages/EmployeeAttendanceDetails';
import CitywiseOnDutyDoctors from './pages/Citywise_on_duty_doctors';
import CitywiseOnDutyDoctorsNew from './pages/Citywise_on_duty_doctors_new';
import SplitDutyRoster from './pages/SplitDutyRoster';
import RegularizeRequestForm from './pages/Regularize/RegularizeRequestForm';
import RegularizeRequestsList from './pages/Regularize/RegularizeRequestsList';

// consultant evaluation
// import ConsultantEvaluation from './pages/ConsultantEvaluation/ConsultantEvaluation';
// import ConsultantEvaluationForm from './pages/ConsultantEvaluation/ConsultantEvaluationForm';
import ConsultantEvaluationList from './pages/consultantEvaluations/ConsultantEvaluationList';
import CreateNewEvaluation from './pages/consultantEvaluations/CreateNewEvaluation';
import ViewSelfEvaluation from './pages/consultantEvaluations/ViewSelfEvaluation';
import ViewAdminEvaluation from './pages/consultantEvaluations/ViewAdminEvaluation';
import EditSelfEvaluation from './pages/consultantEvaluations/EditSelfEvaluation';

import AdminEvaluationList from './pages/consultantEvaluations/AdminEvaluationList';
import EditAdminEvaluation from './pages/consultantEvaluations/EditAdminEvaluation';
import CreateSelfEvaluation from './pages/consultantEvaluations/CreateSelfEvaluation';

import ConsultantSignMaster from './pages/masterPages/ConsultantSignMaster';
import LAB_DIRECTOR_Dashboard from './pages/rolewiseDashboards/LAB_DIRECTOR_Dashboard';

function App() {
     return (
          <Router>
               <Routes>
                    {/* Login */}
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/login_anand" element={<Login_Anand />} />
                    <Route path="/login1" element={<Login1 />} />
                    <Route path="/changepassword" element={<ChangePassword />} />
                    <Route path="/forget-password" element={<ForgetPassword />} />

                    {/* Common protected routes (all authenticated users) */}
                    <Route element={<RoleProtectedRoute allowedRoles={[
                         'SUPER_ADMIN', 'REPORTING_MANAGER', 'HR', 'HRBP', 'EMPLOYEE',
                         'USER_RADIOLOGY', 'USER_INTERNAL', 'HR_RADIOLOGY',
                         'HR_INTERNAL', 'HOD_DOCTORS', 'HOD_CONTRACTUAL',
                         'HOD_POOJARI', 'BRANCH_MANAGER', 'STRATEGY', 'TELE_SUPPORT', 'LAB_DIRECTOR'
                    ]} />}>
                         <Route element={<LayoutWrapper />}>
                              <Route path="/dashboard" element={<Dashboard />} />
                              <Route path="/profile" element={<Profile />} />
                              <Route path="/attendance" element={<Attendance />} />
                              <Route path="/attendance-summary" element={<AttendanceSummary />} />
                              <Route path="/citywise-on-duty-doctors" element={<CitywiseOnDutyDoctors />} />
                              <Route path="/citywise-on-duty-doctors-new" element={<CitywiseOnDutyDoctorsNew />} />

                              <Route path="/holiday" element={<Holiday />} />
                              <Route path="/holiday/edit/:id" element={<HolidayModel />} />
                              <Route path="/holiday/add" element={<HolidayModel />} />

                              <Route path="/roster" element={<Roster />} />
                              <Route path="/roster/edit/:id" element={<RosterEditModel />} />
                              <Route path="/roster/add" element={<RosterModel />} />

                              <Route path="/modality" element={<Modality />} />
                              <Route path="/modality/edit/:id" element={<ModalityEditModel />} />
                              <Route path="/modality/add" element={<ModalityModel />} />

                              <Route path="/submodality" element={<Submodality />} />
                              <Route path="/submodality/edit/:id" element={<SubmodalityEditModel />} />
                              <Route path="/submodality/add" element={<SubmodalityModel />} />

                              <Route path="/submodclass" element={<SubmodClass />} />
                              <Route path="/submodclass/edit/:id" element={<SubmodClassEditModel />} />
                              <Route path="/submodclass/add" element={<SubmodClassModel />} />

                              <Route path="/employee-master" element={<EmployeeMaster />} />
                              <Route path="/dashboard/employee-master/add" element={<EmployeeMaster />} />
                              <Route path="/hr_radiologist/edit/:candidateId" element={<EditHR1RadiologistStatus />} />
                              <Route path="/hrassessments/add" element={<AddHrAssessmentPage />} />

                              <Route path="/radiology-assessment" element={<AssessmentPage1 />} />
                              <Route path="/new-radiology-assessment/*" element={<AssessmentPage1 />} />
                              <Route path="/new-radiology-assessment/:id/view" element={<AssessmentDetail />} />
                              <Route path="/assessments/add" element={<AddAssessmentPage />} />
                              <Route path="/radiologist/view/:candidateId" element={<ViewRadiologistStatus />} />
                              <Route path="/radiologist/manager_edit/:id" element={<EditManagerRadiologistStatus />} />
                              <Route path="/radiologist/edit/:candidateId" element={<EditRadiologistStatus />} />
                              <Route path="/hr-radiology-assessment" element={<HrAssessmentPage />} />
                              <Route path="/radiologist/hr_edit/:id" element={<EditHrRadiologistStatus />} />
                              <Route path="/employee-attendance-details" element={<EmployeeAttendanceDetails />} />
                              {/* Regularize form - accept both paths for backward-compatibility */}
                              <Route path="/regularize-request" element={<RegularizeRequestForm />} />
                              <Route path="/regularize/request" element={<RegularizeRequestForm />} />
                              <Route path="/regularize" element={<RegularizeRequestsList />} />
                         </Route>
                    </Route>

                    {/* ✅ SHARED ROUTES: HR, REPORTING_MANAGER, HOD_DOCTORS, SUPER_ADMIN, STRATEGY */}
                    <Route element={<RoleProtectedRoute allowedRoles={['HR', 'HRBP', 'REPORTING_MANAGER', 'HOD_DOCTORS', 'HOD_CONTRACTUAL', 'SUPER_ADMIN', 'STRATEGY']} />}>
                         <Route element={<LayoutWrapper />}>
                              <Route path="/dutyroster" element={<DutyRoster />} />
                              <Route path="/dutyrosterbulk" element={<DutyRosterBulk />} />
                              <Route path="/employee-attendance" element={<EmployeeAttendance />} />
                         </Route>
                    </Route>

                    {/* HR-only routes */}
                    <Route element={<RoleProtectedRoute allowedRoles={['HR', 'HRBP', 'SUPER_ADMIN']} />}>
                         <Route element={<LayoutWrapper />}>

                              <Route path="/poojari-attendance-summary" element={<PoojariAttendanceSummery />} />
                              <Route path="/payroll" element={<PAYROLL />} />
                              <Route path="/leaves/requests" element={<LeaveRequestsAdmin />} />
                              <Route path="/leaves/calendar" element={<LeaveCalendar />} />
                              <Route path="/leave-management" element={<LeaveManagement />} />
                              <Route path="/leave-management/*" element={<LeaveManagement />} />
                              <Route path="/reset-travel-passwords" element={<ResetTravelPasswords />} />
                              <Route path="/settings" element={<div>Settings Page</div>} />
                              <Route path="/designation" element={<Designation />} />
                              <Route path="/designation/edit/:id" element={<DesignationEditModel />} />
                              <Route path="/designation/add" element={<DesignationModel />} />
                              <Route path="/position" element={<Position />} />
                              <Route path="/position/edit/:id" element={<PositionEditModel />} />
                              <Route path="/position/add" element={<PositionModel />} />
                              <Route path="/paygroup" element={<PAYGROUP />} />
                              <Route path="/paygroup/edit/:id" element={<PaygroupEditModel />} />
                              <Route path="/paygroup/add" element={<PaygroupModel />} />
                              <Route path="/region" element={<REGION />} />
                              <Route path="/region/edit/:id" element={<RegionEditModel />} />
                              <Route path="/region/add" element={<RegionModel />} />
                              <Route path="/city" element={<CITY />} />
                              <Route path="/city/edit/:id" element={<CityEditModel />} />
                              <Route path="/city/add" element={<CityModel />} />
                              <Route path="/cluster" element={<CLUSTER />} />
                              <Route path="/cluster/edit/:id" element={<ClusterEditModel />} />
                              <Route path="/cluster/add" element={<ClusterModel />} />
                              <Route path="/location" element={<LOCATION />} />
                              <Route path="/location/edit/:id" element={<LocationEditModel />} />
                              <Route path="/location/add" element={<LocationModel />} />
                              <Route path="/deptcategory" element={<DEPTCATEGORY />} />
                              <Route path="/deptcategory/edit/:id" element={<DeptCategoryEditModel />} />
                              <Route path="/deptcategory/add" element={<DeptCategoryModel />} />
                              <Route path="/maindept" element={<MAINDEPT />} />
                              <Route path="/maindept/edit/:id" element={<MainDeptEditModel />} />
                              <Route path="/maindept/add" element={<MainDeptModel />} />
                              <Route path="/grade" element={<Grade />} />
                              <Route path="/grade/edit/:id" element={<GradeEditModel />} />
                              <Route path="/grade/add" element={<GradeModel />} />
                              <Route path="/degrees" element={<Degree />} />
                              <Route path="/degrees/add" element={<DegreeModel />} />
                              <Route path="/degrees/edit/:id" element={<DegreeEditModel />} />
                              <Route path="/caste" element={<Caste />} />
                              <Route path="/caste/add" element={<CasteModel />} />
                              <Route path="/caste/edit/:id" element={<CasteEditModel />} />
                              <Route path="/subdept" element={<SubDept />} />
                              <Route path="/subdept/add" element={<SubDeptModel />} />
                              <Route path="/subdept/edit/:id" element={<SubDeptEditModel />} />
                              <Route path="/bloodgroup" element={<BloodGroup />} />
                              <Route path="/bloodgroup/edit/:id" element={<BloodGroupEditModel />} />
                              <Route path="/bloodgroup/add" element={<BloodGroupModel />} />
                              <Route path="/religion" element={<Religion />} />
                              <Route path="/religion/edit/:id" element={<ReligionEditModel />} />
                              <Route path="/religion/add" element={<ReligionModel />} />
                              <Route path="/sbu" element={<SBU />} />
                              <Route path="/sbu/edit/:id" element={<SbuEditModel />} />
                              <Route path="/sbu/add" element={<SbuModel />} />

                         </Route>
                    </Route>

                    {/* EMPLOYEE only routes */}
                    <Route element={<RoleProtectedRoute allowedRoles={['EMPLOYEE', 'REPORTING_MANAGER', 'HOD_DOCTORS', 'HOD_CONTRACTUAL', 'HR', 'HRBP', 'SUPER_ADMIN']} />}>
                         <Route element={<LayoutWrapper />}>
                              <Route path="/leaves/my" element={<MyLeaves />} />
                              <Route path="/leaves/calendar" element={<LeaveCalendar />} />
                              <Route path="/leave-management" element={<LeaveManagement />} />
                              <Route path="/leave-management/*" element={<LeaveManagement />} />
                              <Route path="/leaves/requests" element={<LeaveRequestsAdmin />} />
                         </Route>
                    </Route>

                    {/* Employee route */}
                    <Route element={<RoleProtectedRoute allowedRoles={['EMPLOYEE', 'SUPER_ADMIN']} />}>
                         <Route element={<LayoutWrapper />}>
                              <Route path="/consultant-evaluations" element={<ConsultantEvaluationList />} />
                              <Route path="/create-self-evaluation" element={<CreateSelfEvaluation />} />
                              <Route path="/edit-self-evaluations/:id/edit" element={<EditSelfEvaluation />} />
                              <Route path="/view-self-evaluations/:id" element={<ViewSelfEvaluation />} />
                         </Route>
                    </Route>

                    <Route element={<RoleProtectedRoute allowedRoles={['HOD_DOCTORS', 'HOD_CONTRACTUAL', 'HR', 'HRBP', 'SUPER_ADMIN', 'REPORTING_MANAGER']} />}>
                         <Route element={<LayoutWrapper />}>

                              <Route path="/employee-attendance/calendar" element={<EmployeeAttendanceCalendar />} />
                              <Route path="/split-duty-roster" element={<SplitDutyRoster />} />
                         </Route>
                    </Route>

                    {/* HOD_DOCTORS only routes */}
                    <Route element={<RoleProtectedRoute allowedRoles={['HOD_DOCTORS', 'HR', 'HRBP', 'SUPER_ADMIN']} />}>
                         <Route element={<LayoutWrapper />}>
                              <Route path="/manager-radiology-assessment" element={<ManagerAssessmentPage />} />
                              <Route path="/doctor-attendance-summary" element={<DoctorAttendanceSummary />} />
                              <Route path="/doctors-shift-master" element={<DoctorsShiftMaster />} />
                              <Route path="/employee-shift-master" element={<EmployeeShiftMaster />} />
                         </Route>
                    </Route>

                    {/* HOD_CONTACTUAL only routes */}
                    <Route element={<RoleProtectedRoute allowedRoles={['HOD_CONTRACTUAL', 'HR', 'HRBP', 'SUPER_ADMIN', 'STRATEGY']} />}>
                         <Route element={<LayoutWrapper />}>
                              <Route path="/employee-attendance-summary" element={<EmployeeAttendanceSummar />} />
                         </Route>
                    </Route>

                    {/* REPORTING_MANAGER only routes */}
                    <Route element={<RoleProtectedRoute allowedRoles={['REPORTING_MANAGER', 'SUPER_ADMIN']} />}>
                         <Route element={<LayoutWrapper />}>
                              <Route path="/manager-radiology-assessment" element={<ManagerAssessmentPage />} />
                              <Route path="/employee-attendance/calendar" element={<EmployeeAttendanceCalendar />} />
                         </Route>
                    </Route>

                    {/* SUPER_ADMIN only routes */}
                    <Route element={<RoleProtectedRoute allowedRoles={['SUPER_ADMIN']} />}>
                         <Route element={<LayoutWrapper />}>
                              <Route path="/users" element={<USERS />} />
                              <Route path="/users/edit/:id" element={<UserEditModel />} />
                              <Route path="/users/add" element={<UserModel />} />
                              {/* consultants sign master */}
                              <Route path="/consultant-sign-master" element={<ConsultantSignMaster />} />
                              {/* lab director dashboard */}
                              <Route path="/lab-director-dashboard" element={<LAB_DIRECTOR_Dashboard />} />
                         </Route>
                    </Route>

                    {/* LAB_DIRECTOR only routes */}
                    <Route element={<RoleProtectedRoute allowedRoles={['LAB_DIRECTOR', 'SUPER_ADMIN']} />}>
                         <Route element={<LayoutWrapper />}>
                              <Route path="/admin-evaluations" element={<AdminEvaluationList />} />
                              {/* edit admin evaluation */}
                              <Route path="/admin-evaluations/:id/edit" element={<EditAdminEvaluation />} />
                              {/* ViewAdminEvaluation */}
                              <Route path="/admin-evaluations/:id" element={<ViewAdminEvaluation />} />

                         </Route>
                    </Route>

                    {/* Fallback */}
                    <Route path="*" element={<Login />} />
               </Routes>
          </Router>
     );
}

export default App;